/** Primitives partagées par les moteurs (internes à engines/). */

/** Voisinage 4-connexe : haut, droite, bas, gauche (index.html:307). */
export const D4: ReadonlyArray<readonly [number, number]> = [
  [-1, 0],
  [0, 1],
  [1, 0],
  [0, -1],
];

/** Grille N×N remplie de `v` (index.html:306). */
export function mk<T>(n: number, v: T): T[][] {
  return Array.from({ length: n }, () => new Array<T>(n).fill(v));
}

/** Copie profonde d'un objet sérialisable (index.html:304). */
export function deep<T>(o: T): T {
  return JSON.parse(JSON.stringify(o)) as T;
}
